import { createTheme } from '@mantine/core'

export const theme = createTheme({
  primaryColor: 'blue',
  autoContrast: true,
  luminanceThreshold: 0.35,
  defaultRadius: 'md',
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  fontFamilyMonospace: 'JetBrains Mono, Monaco, "Cascadia Code", "Roboto Mono", Consolas, "Courier New", monospace',
  headings: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeight: '600',
  },
  components: {
    AppShell: {
      styles: {
        main: {
          background: 'var(--app-background)',
        },
      },
    },
    Paper: {
      defaultProps: {
        withBorder: true,
      },
    },
    Card: {
      defaultProps: {
        withBorder: true,
      },
    },
    Modal: {
      defaultProps: {
        centered: true,
        radius: 'md',
      },
    },
    Drawer: {
      defaultProps: {
        radius: 'md',
      },
    },
  },

  other: {
    colors: {
      'app-background': 'var(--app-background)',
      'app-background-dark': 'var(--app-background-dark)',
    },
  },
})
